var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPolestar = function SvgPolestar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M500 494.658V211.351L510.692 198L558.954 435.922L797 483.982L786.308 494.658H500ZM497.329 505.342V788.649L489.308 802L438.519 564.078L203 516.018L213.692 505.342H497.329Z",
    fill: "#A6ACB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M500 494.665H786.308L797 484.002L558.954 436L500 494.665ZM497.329 505.335H213.692L203 515.998L438.519 564L497.329 505.335Z",
    fill: "#A6ACB2"
  })));
};
export default SvgPolestar;